import { useEffect, useRef, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { userManager } from '../components/OidcAuthProvider';
import { PATHS } from '../constants/Paths.constants';
import { isLogoutInProgress } from '../utils/Auth.util';
import { useAppSelector } from '../hooks/redux';

export function OidcLoginRedirectPage() {
  const started = useRef(false);
  const [error, setError] = useState<string | null>(null);
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const location = useLocation();
  const loginHint = (location.state as { loginHint?: string } | null)
    ?.loginHint;

  useEffect(() => {
    if (isAuthenticated || started.current) {
      return;
    }

    started.current = true;

    if (isLogoutInProgress()) {
      return;
    }

    void userManager
      .signinRedirect({
        state: { returnTo: PATHS.DASHBOARD },
        ...(loginHint ? { login_hint: loginHint } : {})
      })
      .catch((signinError) => {
        console.error('[OIDC] signinRedirect error:', signinError);
        setError('Unable to redirect to identity provider. Please try again.');
      });
  }, [loginHint, isAuthenticated]);

  if (isAuthenticated) {
    return <Navigate to={PATHS.DASHBOARD} replace />;
  }

  if (isLogoutInProgress()) {
    return <Navigate to={PATHS.LOGOUT} replace />;
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <p className="text-red-600 mb-4">{error}</p>
          <button
            className="text-purple-700 underline"
            onClick={() => {
              setError(null);
              started.current = false;
            }}
          >
            Try again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <p className="text-gray-500">Redirecting to sign in...</p>
    </div>
  );
}
